import edit from '../Images/edit.png'
import config from "../config.json";
import profileEdit from '../Images/contact.jpg'
//import QrCodeGet from './QrCodeGet'
import './Main.css'
import add from '../Images/add.png'
import play from '../Images/play.png'
import barcode from '../Images/barcode.png'
import ConfirmDialog from './ConfirmDialog'
import person from '../Images/personWhite.png'
import mobileWhite from '../Images/mobileWhite.png'
import instagram from '../Images/instagram.png'
import telegram from '../Images/telegram.png'
import pernsil from '../Images/pernsil.png'
import delete1 from '../Images/delete.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import horzintalLine from '../Images/horzintalLine.png'
import verticalLine from '../Images/verticalLine.png'
import { toast } from "react-toastify";

export default function Main() {
    let navigate = useNavigate();
    const [list, setList] = useState([])


    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        loadList()
        GetProfile()
    }, []);

    const [previewImge, setPreviewImge] = useState(null);

    const [userInfo, setUserInfo] = useState({})
    const [isLoadingUser, setIsLoadingUser] = useState(false);
    const GetProfile = async () => {
        setIsLoadingUser(true);
        await Services.getProfile()
            .then(({ data }) => {
                setIsLoadingUser(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setUserInfo(data.payload);
                setPreviewImge(`${config.apiUrl}/pic/${data.payload.id}.jpg?${new Date().getTime()}`);
            })
            .catch(err => {
                setIsLoadingUser(false);
            });
    }


    const [isLoading, setIsLoading] = useState(false);
    const loadList = async () => {
        setIsLoading(true);
        await Services.QrCodeList()
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setList(data.payload);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }
    const [idChoice, setIdChoice] = useState(0)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [isDeleteing, setIsDeleteing] = useState(false)
    const doDelete = async (e) => {
        e.preventDefault();
        setIsDeleteing(true);
        await Services.QrCodeDelete(idChoice)
            .then(({ data }) => {
                setIsDeleteing(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setShowConfirmDelete(false)
                loadList()
            })
            .catch(err => {
                setIsDeleteing(false);
            });
    }

    /*
    const [isPosting, setIsPosting] = useState(false)
    const [showConfirmNewBarCode, setShowConfirmNewBarCode] = useState(false)
    const [code, setCode] = useState("")
    const doAddBarcode = async (e) => {
        e.preventDefault();
        setIsPosting(true);
        await Services.QrCodeNew1({ code: code })
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setShowConfirmNewBarCode(false)
                loadList()
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    const [showQrCodeGet, setShowQrCodeGet] = useState(false)
    const [isBusy, setIsBusy] = useState(false)
    const choiceBarcode = (e) => {
        setShowQrCodeGet(false);
    }
*/
    const logOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        http.logout();
        navigate('/login');
    }

    return (
        <>
            {/*showQrCodeGet &&
                <QrCodeGet
                    isBusy={isBusy}
                    handleClose={e => { setShowQrCodeGet(false) }}
                    show={showQrCodeGet}
                    onChoice={choiceBarcode} />
            */}
            <ConfirmDialog
                show={showConfirmDelete}
                title={"حذف برچسب"}
                handleDo={doDelete}
                handleCancel={() => { setShowConfirmDelete(false) }}
                isBusy={isDeleteing}
            >
                <div className='row'>
                    <div className='col alert alert-danger'>
                        آیا از حذف این برچسب اطمینان دارید؟
                    </div>
                </div>
            </ConfirmDialog >


            <div className="row mb-2" id="profileData">
                <div className="col-auto d-flex align-items-center">

                    <img
                        src={previewImge ? previewImge : profileEdit}
                        className=''
                        id="picProfile"
                        onError={() => { setPreviewImge(null) }}
                    />
                    <Link to="/profile"                        >
                        <img
                            src={edit}
                            className=''
                            id="editPencil2" />
                    </Link>
                </div>
                <div className='col d-flex align-items-center'>
                    {isLoadingUser && <div className="spinner-border spinner-border-sm" role="status" />}
                    {!isLoadingUser &&
                        <div className='w-100'>
                            <div className="row">
                                <div className='col p-2'>
                                    <div className='row'>
                                        <div className='col p-2 '>
                                            <Link className="text-decoration-none  " to="/profile">
                                                <img src={person} className='me-2' />
                                                <span className='text-white  ' id="displayNameMain">{userInfo.name}</span>
                                            </Link>
                                            <Link
                                                className="text-decoration-none ms-1  "
                                                onClick={logOut}>
                                                <span className='px-2 fs-7'>خروج</span>
                                            </Link>

                                        </div>
                                        <div className="row p-0">
                                            <div className='col p-0 d-flex justify-content-center'>
                                                <img src={horzintalLine} />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className='col p-2'>
                                                <Link className="text-decoration-none  " to="/profile">
                                                    <img src={mobileWhite} className='me-2' />
                                                    <span className='text-white'>{userInfo.mobile}</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <img src={verticalLine} />
                                </div>
                                <div className="col p-2">
                                    <div className='row'>
                                        <div className='col p-2 '>
                                            <Link className="text-decoration-none  " to="/profile">
                                                <img src={instagram} className='me-2' />
                                                <span className='text-white'>{`${!userInfo.instagram || userInfo.instagram == "" ? "وارد نشده" : userInfo.instagram}`}</span>
                                            </Link>
                                        </div>
                                        <div className="row p-0">
                                            <div className='col p-0 d-flex justify-content-center'>
                                                <img src={horzintalLine} />
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col p-2'>
                                                <Link className="text-decoration-none  " to="/profile">
                                                    <img src={telegram} className='me-2' />
                                                    <span className='text-white'>{`${!userInfo.telegram || userInfo.telegram == "" ? "وارد نشده" : userInfo.telegram}`}</span>
                                                </Link>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>}
                </div>
            </div >

            <div className='row mt-3 '  >
                <div className='col boxBarcode p-3 d-flex me-3'>
                    <div><img src={barcode} className="me-2" /></div>
                    <span className="text-white">تعداد بارکدهای ثبت شده :{list.length}</span>
                </div>
                <div className='col-auto boxBarcode p-3 d-flex'>
                    <img src={play} className="me-2" />
                    <span className="text-white">آموزش</span>
                </div>
            </div>

            <div className='row mt-4 p1-3' id="rowBarcodes">
                <div className='col'>
                    <div className='row'>
                        <div className='col fs-4'>
                            کدهای ثبت شده
                        </div>
                    </div>
                    <div className='row mt-1'>
                        <div className='col '>
                            {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
                            {list.map((x, i) => (
                                <div key={i + "row"} className='row p1-2 ' id="rowBarcode">
                                    <div className='col'>
                                        <div className='row'>
                                            <div className='col col-md col-3'>
                                                {'name' in x && x.name}
                                            </div>
                                            <div className='col'>
                                                {x.code}
                                            </div>
                                            <div className='col-auto p-0'>
                                                <Link
                                                    className="text-decoration-none btn-edit p-2"
                                                    to={`/edit/${x.id}`}>
                                                    <img src={pernsil} className='' />
                                                    <span className='px-2 fs-7'>ویرایش</span>
                                                </Link>
                                                <Link
                                                    className="ms-2 text-decoration-none  p-2"
                                                    to="/"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setIdChoice(x.id);
                                                        setShowConfirmDelete(true);
                                                    }}>
                                                    <img src={delete1} className='' />
                                                </Link>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            </div>
            <div className='row mt-3 '  >
                <div className='col '>
                    <Link
                        className="w-100 btn btn-lg btn1 py-3 text-decoration-none "
                        to="/new" >
                        <img src={add} className="me-2" /><span>برای افزودن برچسب محصول جدید کلیک کنید</span>
                    </Link>
                </div>
            </div>
            {/*
            <div className="fixed-bottom container">
                <div className='row '>
                    <div className='col col-md-10 mx-auto col-lg-5'>



                        <div className='row  '  >
                            <div className='col d-flex justify-content-center '>
                                <Link
                                    className="  btn btnColor1 text-decoration-none"
                                    to="/new"
                                >
                                    افزودن بارکد جدید
                                </Link>
                            </div>
                            <div className='col d-flex justify-content-center '>
                                <button
                                    className="  btn text-white "
                                >
                                    پروفایل
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            */
            }
        </>

    );

}
